import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Typography, Paper } from "@mui/material";

const columns = [
  { field: "userEmail", headerName: "Email", flex: 1, minWidth: 150 },
  { field: "leaveType", headerName: "Leave Type", flex: 1, minWidth: 150 },
  { field: "leaveReason", headerName: "Leave Reason", flex: 1, minWidth: 150 },
  { field: "startDate", headerName: "Start Date", flex: 1, minWidth: 100 },
  { field: "endDate", headerName: "End Date", flex: 1, minWidth: 100 },
  { field: "status", headerName: "Status", flex: 1, minWidth: 100 },
];

export default function EmployeesOnLeaveTable() {
  const [rows, setRows] = useState([]);
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  useEffect(() => {
    const fetchEmployeesOnLeave = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_LMS}/EmployeesOnLeaveToday`,
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          }
        );
        const data = await response.json();

        if (data.status === "200" && Array.isArray(data.data)) {
          const rowsWithId = data.data.map((leave, index) => ({
            id: index + 1,
            userEmail: leave.userEmail,
            leaveType: leave.leaveType,
            leaveReason: leave.leaveReason,
            startDate: leave.startDate,
            endDate: leave.endDate,
            status: leave.status,
          }));

          setRows(rowsWithId);
        }
      } catch (error) {
        console.error("Error fetching employees on leave:", error);
      }
    };

    fetchEmployeesOnLeave();
  }, []);

  return (
    <Box p={0}>
      <Typography variant="h5" gutterBottom>
        Employees on Leave Today [ {rows.length} ]
      </Typography>
      <Paper elevation={3} sx={{ padding: 0 }}>
        <div style={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            sx={{
              fontSize: "14px",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "rgb(100, 95, 95)",
                color: "white",
              },
              "& .MuiDataGrid-cell": { textAlign: "center" },
            }}
          />
        </div>
      </Paper>
    </Box>
  );
}
